import { render, staticRenderFns } from "./LeafletCustomIcon.vue?vue&type=template&id=56311848"
import script from "./LeafletCustomIcon.vue?vue&type=script&lang=js"
export * from "./LeafletCustomIcon.vue?vue&type=script&lang=js"
import style0 from "./LeafletCustomIcon.vue?vue&type=style&index=0&id=56311848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports